import { createContext, useContext } from 'react'
import { type BroadcastDetailRecurringStore } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring'

export const BroadcastDetailRecurringContext = createContext<BroadcastDetailRecurringStore | null>(
  null
)

export function useBroadcastDetailRecurringContext() {
  const context = useContext(BroadcastDetailRecurringContext)
  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with BroadcastDetailRecurringContext'
    )
  }
  return context
}
